import { TestDataFeatureDto } from "src/types/TestDataFeatureDto";
import { HttpMethod } from "../types/HttpMethod";

const testDataApiUrl = `${process.env.REACT_APP_BASE_URL}/rs/automation/testData`;

export const getAllTestDataFiles = (
  auth: string,
  productCode: string,
  clientCode: string
) => {
  const url = `${testDataApiUrl}/${productCode}/get?clientCode=${clientCode}`;
  return fetch(url, {
    method: HttpMethod.Get,
    headers: {
      Authorization: auth,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const saveTestDataFile = (
  testData: any,
  testDataFeatureDto: TestDataFeatureDto,
  auth: string,
  testDataFileName: string,
  orgCode: string,
  productCode: string,
  clientCode: string
) => {
  const url = `${testDataApiUrl}/${productCode}/save?testDataFileName=${testDataFileName}&orgCode=${orgCode}&clientCode=${clientCode}`;

  const requestBody = {
    testDataFile: testData,
    testDataFeatureDTO: testDataFeatureDto,
  };

  return fetch(url, {
    method: HttpMethod.Post,
    headers: {
      Authorization: auth,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });
};

export const downLoadTestDataFiles = (
  auth: string,
  testDataNames: string[],
  isDefault: Boolean,
  orgCode: String,
  productCode: string,
  clientCode: string
) => {
  const url = `${testDataApiUrl}/${productCode}/download?isDefault=${isDefault}&orgCode=${orgCode}&clientCode=${clientCode}`;
  return fetch(url, {
    method: HttpMethod.Post,
    headers: {
      Authorization: auth,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(testDataNames),
  });
};

export const uploadTestDataFiles = (
  testDataFiles: File[],
  testDataFeatureDto: TestDataFeatureDto,
  orgCode: string,
  auth: string,
  productCode: string,
  clientCode: string
) => {
  const url = `${testDataApiUrl}/${productCode}/testDataFilesUpload?orgCode=${orgCode}&clientCode=${clientCode}`;

  const formData = new FormData();

  Array.from(testDataFiles).forEach((file) => {
    formData.append(`testDataFiles`, file);
  });
  formData.append("testDataFeatureDTO", JSON.stringify(testDataFeatureDto));

  return fetch(url, {
    method: HttpMethod.Post,
    headers: {
      Authorization: auth,
      Accept: "application/json",
    },
    body: formData,
  });
};

export const deleteTestDataFiles = (
  testDataFiles: string[],
  testDataFeatureDto: TestDataFeatureDto,
  orgCode: string,
  auth: string,
  productCode: string,
  clientCode: string
) => {
  const url = `${testDataApiUrl}/${productCode}/delete?orgCode=${orgCode}&clientCode=${clientCode}`;

  const requestBody = {
    testDataNames: testDataFiles,
    testDataFeatureDTO: testDataFeatureDto,
  };

  return fetch(url, {
    method: HttpMethod.Delete,
    headers: {
      Authorization: auth,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });
};
